import React, { useEffect } from "react";
import store from "../../store";
import { SET_IS_SHOW_NEXT } from "../../store/actions/nextBtn";

interface LoaderProps{
    footerLoader? :boolean;
}
export default function Loader(props: LoaderProps){
    const {footerLoader} = props;
    const dispatchIsHideNextToStore = (showNext : boolean) =>{
        store.dispatch({
          type: SET_IS_SHOW_NEXT,
          state: showNext
        });
    }
    useEffect(() =>{
        dispatchIsHideNextToStore(true);
    },[])
    useEffect(() => {
        return () => {
            dispatchIsHideNextToStore(false);
        };
      }, []);
    return(
       <div className={footerLoader ? 'page-loader footer-loader' : 'page-loader'}>
            <div className="loader"></div>
        </div> 
    )
}
